import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import rules from "../../../utils/rules";
import smsServiceNew from "../../../api/reservePlanNew.service";
import constants from "../../../config/constants";

import moment from "moment";
import XLSX from "xlsx";
export default {
  name: "create-planning-sheet",
  components: { pageheader },
  data() {
    return {
      input: {},
      rules: rules,
      valid: true,
      expanded: [],
      singleExpand: false,
      errorMSG: "",
      isComponentDestroyed: false,
      companyIdWaitTimer: null,
      showdialog: false,
      planningSheetItemObject: {},
      planningSheetObject: {
        birchUserID: "",
        canDeletePlanningSheet: "",
        canLockPlanningSheet: "",
        projectionCreatorName: "",
        projectionCreatorUserID: "",
        projectionEndDate: "",
        projectionID: "",
        projectionJobComments: "",
        projectionJobNo: "",
        projectionJobSite: {},
        projectionJobSiteNo: "",
        projectionLocation: "",
        projectionName: "",
        projectionPONo: "",
        projectionStartDate: "",
        projectionStatus: "",
        quantity: 1,
        shift: 1,
        isDeliveryRequired: false,
        projectionItemOperatorCertification: false,
      },
      jobSiteList: [],
      menu1: false,
      menu2: false,
      menu2CreateDialog: false,
      menu1CreateDialog: false,
      conactsList: [],
      selectedContact: [],
      contactSearchFilter: "",
      approverSearchFilter: "",
      approversList: [],
      selectedApprover: [],
      defaultShiftOptions: [
        { name: "Standby", value: 0 },
        { name: "Single", value: 1 },
        { name: "Double", value: 2 },
        { name: "Triple", value: 3 },
      ],
      shiftSearchFilter: "",
      isSaveBtn: false,
      planningSheetDataResponse: {},
      projectionItems: [],
      categorylistOriginal: [],
      categorylist: [],
      categoryclick: false,
      groupclick: false,
      departmentclick: false,
      showequipmentDetailsClick: false,
      equipmentDetailsobj: {},
      isItemsNotified: false,
      isItemsLocked: false,
      itemSettingsFormValid: true,
      itemSettingsmenu1: false,
      itemSettingsmenu2: false,
      itemsPostConfirmDialog: false,
      addItemPlanningSheet: false,
      i: 0,
      isReviewDataLoading: false,
      estimatedCost: 0.0,
      reviewSheetList: [],
      reviewSubTableHeaders: [
        { text: "", value: "expand", sortable: "false", width: "55px" },
        { text: "Actions", value: "actions", width: "150px" },

        {
          text: "Date Modified",
          value: "projectionItemRevisionDate",
          width: "100px",
        },
        {
          text: "Equipment Name",
          value: "projectionItemEquipmentDescription",
          width: "200px",
        },
        {
          text: "Equipment Number",
          value: "projectionItemEquipment",
          width: "130px",
          class: `main-header table-header-padding`,
        },
        {
          text: "Start Date",
          value: "projectionItemStartDate",
          width: "100px",
        },
        { text: "End Date", value: "projectionItemEndDate", width: "100px" },
        { text: "Qty", value: "projectionItemQuantity", width: "80px" },
        { text: "Job#", value: "jobNo", width: "100px" },
        { text: "Shifts", value: "projectionItemShifts", width: "100px" },
        {
          text: "Cert. Needed",
          value: "projectionItemOperatorCertification",
          width: "100px",
          class: `main-header table-header-padding`,
        },
        { text: "Delivery", value: "projectionItemDelivery", width: "100px" },
        { text: "PO#", value: "poNo", width: "100px" },
        {
          text: "Picked Up By",
          value: "pickedUpBy",
          width: "100px",
          class: `main-header table-header-padding`,
        },
        {
          text: "Ordered By",
          value: "orderedBy",
          width: "100px",
          class: `main-header table-header-padding`,
        },
      ],
      reviewTableHeaders: [
        { text: "Actions", value: "actions", width: "150px" },

        {
          text: "Date Modified",
          value: "projectionItemRevisionDate",
          width: "100px",
        },
        {
          text: "Equipment Name",
          value: "projectionItemEquipmentDescription",
          width: "200px",
        },
        {
          text: "Equipment Number",
          value: "projectionItemEquipment",
          width: "130px",
          class: `main-header table-header-padding`,
        },
        {
          text: "Start Date",
          value: "projectionItemStartDate",
          width: "100px",
        },
        { text: "End Date", value: "projectionItemEndDate", width: "100px" },
        { text: "Qty", value: "projectionItemQuantity", width: "80px" },
        { text: "Job#", value: "jobNo", width: "100px" },
        { text: "Shifts", value: "projectionItemShifts", width: "100px" },
        {
          text: "Cert. Needed",
          value: "projectionItemOperatorCertification",
          width: "100px",
          class: `main-header table-header-padding`,
        },
        { text: "Delivery", value: "projectionItemDelivery", width: "100px" },
        { text: "PO#", value: "poNo", width: "100px" },
        {
          text: "Picked Up By",
          value: "pickedUpBy",
          width: "100px",
          class: `main-header table-header-padding`,
        },
        {
          text: "Ordered By",
          value: "orderedBy",
          width: "100px",
          class: `main-header table-header-padding`,
        },
      ],
      search: "",
      excelHeader: [],
      isRefreshBtn: false,
      isItemsSubmit: false,
      isReviewRecordDelete: false,
      reviewDeleteObj: {},
      reviewDeleteDialog: false,
      customRatesDialog: false,
      customRateItemObj: {},
      ratesFormValid: true,
      isUpdateCustomRates: false,
      categoryNameList: [],
      depNameList: [],
      groupNameList: [],
      catTrue: false,
      depTrue: false,
      grpTrue: false,
      imgCategoryName: "",
      searchCategoryList: [],
      planningSheetTab: 1,
      SuggestedItems: [],
      isSugAddCheck: false,
      masterItems: [],
      masterItemsLoading: false,
      unlistedEquipmentDialog: false,
      isUnlistedEquipment: false,
      unlistedEquipmentType: "",
      newItemAddAfterReview: false,
      unlisteditemSettingsmenu2: false,
      unlisteditemSettingsmenu1: false,
      sugLoading: false,
      jobSiteRadioInput: "1",
      newJobSite: "",
      addSearchTerm: "",
      searchTermChips: [],
      equipmentGlobalSearch: [],
      hideAllCategoryBtn: false,
      rejectConfirmationDialog: false,
      approveConfirmationDialog: false,
      rejectionReason: "",
      isRejectItems: false,
      isApprover: false,
      copyProjectionId: "",
      isJobsiteLoading: false,
      isApproversLoading: false,
      isContactsLoading: false,
      createPlanningSheetDialog: false,
      createForm: true,
      selectedItemAtTimeOfCreation: "",
      refreshJobSiteRadio: true,
      notesDialog: false,
      additionalNotes1: null,
      additionalNotes2: null,
      itemId: null,
      isSaveNotesLoading: false,
      parentKey: "",
      sharableLink: "",
      isSharableLinkGenerated: false,
    };
  },
  computed: {
    ...mapGetters([
      "roles",
      "planningSheetObj",
      "smsUserId",
      "storeProjectionID",
      "storeProjectionItemEquipment",
      "storeProjectionItemID",
      "storeReserveType",
      "createPlanningSheetTab",
      "createPlanningSheetTabPrev",
      "isReviewImage",
      "projectionItemRoute",
      "copyOfProjectionName",
      "companyIdDropdown",
      "smsCustomerLinkingId",
      "smsBirchLinkingId",
      "shift",
      "smsUserPermissions",
    ]),
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      }
    },
    USCurrencyFormat: function (value) {
      if (value || value == 0) {
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(value);
      }
    },
  },
  created() {
    this.planningSheetTab = this.$router.currentRoute.params.sheetId
      ? 3
      : this.createPlanningSheetTab;
  },
  async mounted() {
    this.input = utils.getInputContent("createNewPlanningSheet", this.roles);

    if (
      this.$store.getters.companyIdDropdown == null ||
      this.$store.getters.companyIdDropdown == "" ||
      this.$store.getters.companyIdDropdown == undefined
    ) {
      this.errorMSG = constants.ERROR_COMPANY_NOT_SELECTED;
    } else {
      this.errorMSG = "";
      if (this.planningSheetTab != 2) {
        this.resetProjectionItemSelected();
      }
      await window.localStorage.setItem("masterItems", JSON.stringify([]));
      this.masterItems = [];
      if (this.planningSheetTab == 2) {
        this.getMasterItemsList(true);
      } else {
        this.initialCalls();
      }
    }
    if (
      this.smsUserPermissions &&
      this.smsUserPermissions.seeRatesOnPlanningSheets
    ) {
      this.reviewTableHeaders.splice(
        7,
        0,
        ...[
          { text: "Daily Rate", value: "dailyRate", width: "100px" },
          { text: "Weekly Rate", value: "weeklyRate", width: "100px" },
          { text: "Monthly", value: "monthlyRate", width: "100px" },
          { text: "Sale Price", value: "salePrice", width: "100px" },
          { text: "Est Cost", value: "projectionItemEstCost", width: "100px" },
        ]
      );
      this.reviewSubTableHeaders.splice(
        8,
        0,
        ...[
          { text: "Daily Rate", value: "dailyRate", width: "100px" },
          { text: "Weekly Rate", value: "weeklyRate", width: "100px" },
          { text: "Monthly", value: "monthlyRate", width: "100px" },
          { text: "Sale Price", value: "salePrice", width: "100px" },
          { text: "Est Cost", value: "projectionItemEstCost", width: "100px" },
        ]
      );
    }
    if (this.$router.currentRoute.params.sheetId) {
      this.$store.dispatch(
        "setStoreProjectionID",
        this.$router.currentRoute.params.sheetId
      );
      this.$store.dispatch("setStoreReserveType", "View");
      await this.getPlanningSheetById();
    }

    const waitForCompanyId = async () => {
      while (!this.$store.getters.companyIdDropdown) {
        //the poller outlives the page otherwise - companyIdDropdown stays
        //empty while the toolbar is on "All", so this loop never ends
        if (this.isComponentDestroyed) {
          return;
        }
        await new Promise((resolve) => {
          this.companyIdWaitTimer = setTimeout(resolve, 100);
        });
      }
      if (this.isComponentDestroyed) {
        return;
      }
      this.errorMSG = "";
      if (this.planningSheetTab !== 2) {
        this.resetProjectionItemSelected();
      }
      this.initialCalls();
    };

    waitForCompanyId();
  },
  beforeDestroy() {
    this.isComponentDestroyed = true;
    clearTimeout(this.companyIdWaitTimer);
  },
  methods: {
    generateSharableLink() {
      this.isSharableLinkGenerated = true;
      this.sharableLink = window.location.href + "/" + this.storeProjectionID;
      navigator.clipboard.writeText(this.sharableLink);
      this.isSharableLinkGenerated = false;
      this.$toast.success("Link copied to clipboard");
    },
    disablePastDates(val) {
      return val >= new Date().toISOString().substr(0, 10);
    },
    counter() {
      this.i = this.i + 1;
    },
    initialCalls() {
      if (this.planningSheetTab == 1 && !this.storeProjectionID) {
        this.planningSheetObject.shift = 1;
      }
      this.getJobSiteList();
      this.getApprovers();
      this.getContacts();
      this.getProjectionItemsList();
      this.projectionItems = this.masterItems;
      //show & Refresh review sheet data while navigate after new sheet creation/navigate through view project flow
      if (this.planningSheetTab == 3 && this.storeReserveType == "View") {
        this.goToReviewPlanningSheet();
      }
      if (
        this.planningSheetTab == 1 &&
        this.storeReserveType == "View" &&
        this.storeProjectionID
      ) {
        this.planningSheetObject = this.planningSheetObj;
        if (this.planningSheetObject.projectionJobSiteNo != null) {
          this.jobSiteRadioInput = "1";
        } else {
          this.jobSiteRadioInput = "2";
          this.newJobSite = this.planningSheetObject.projectionJobSite;
        }
      }
      //Prefill sheet data when click edit of project
      if (this.planningSheetTab == 1 && this.storeReserveType == "Edit") {
        this.getReviewObjDataInEditFlow();
      }
      if (this.planningSheetTab == 3 && this.storeReserveType == "Edit") {
        this.getReviewSheetList();
      }
      //Prefill sheet data when click copy of project
      if (this.planningSheetTab == 1 && this.storeReserveType == "Copy") {
        this.getReviewObjDataInCopyFlow();
      }
      if (this.planningSheetTab == 3 && this.storeReserveType == "Copy") {
        this.getReviewSheetList();
      }
      // show all caltegories and items list on general page refresh when page value is 2
      if (
        this.planningSheetTab == 2 &&
        this.storeProjectionItemEquipment &&
        !this.storeProjectionItemID
      ) {
        this.$store.dispatch("setPlanningSheetTab", 2);
        this.planningSheetTab = this.createPlanningSheetTab;
        this.getProjectionItemsList();
      }
      // show items settings page & it's date on page refresh from edit mode of review table
      if (
        this.planningSheetTab == 2 &&
        this.storeProjectionItemEquipment &&
        this.storeProjectionItemID
      ) {
        this.$store.dispatch("setPlanningSheetTab", 2);
        this.planningSheetTab = this.createPlanningSheetTab;
        this.getProjectionItemsList();

        let a = this.masterItems.filter(
          (e) => e.itemKey == this.storeProjectionItemEquipment
        );
        this.showequipmentDetails(a[0], true);

        let item =
          this.planningSheetObj &&
          this.planningSheetObj.birchProjectionItems &&
          this.planningSheetObj.birchProjectionItems.filter(
            (e) => e.projectionItemID == this.storeProjectionItemID
          );

        if (item && item.length == 1) {
          this.setItemSettings(item[0]);
        }
      }
    },
    async getMasterItemsList(
      isInitial,
      isReviewTab = false,
      isLoadPreviousSelectedItem = false
    ) {
      this.masterItemsLoading = true;
      this.masterItems = [];
      try {
        let response = await smsServiceNew.getItemsList(
          this.storeReserveType
            ? this.planningSheetObj.projectionJobSiteNo
              ? this.planningSheetObj.projectionJobSiteNo
              : ""
            : ""
        );
        if (response.data) {
          this.masterItems = response.data;
          await window.localStorage.setItem(
            "masterItems",
            JSON.stringify(response.data)
          );
        } else {
          this.masterItems = [];
          await window.localStorage.setItem("masterItems", JSON.stringify([]));
        }

        if (isInitial) {
          this.initialCalls();
        } else {
          this.getProjectionItemsList();
          if (isLoadPreviousSelectedItem) {
            this.getItemInfoById(
              this.planningSheetObject,
              this.selectedItemAtTimeOfCreation
            );
          }
          if (isReviewTab) {
            this.isReviewDataLoading = false;
          }
        }

        this.masterItemsLoading = false;
      } catch (err) {
        if (isInitial) {
          this.initialCalls();
        } else {
          this.getProjectionItemsList();
          if (isLoadPreviousSelectedItem) {
            this.getItemInfoById(
              this.planningSheetObject,
              this.selectedItemAtTimeOfCreation
            );
          }
          if (isReviewTab) {
            this.isReviewDataLoading = false;
          }
        }
        await window.localStorage.setItem("masterItems", JSON.stringify([]));
        this.masterItemsLoading = false;
        console.log(err);
      }
    },
    tabChange(tab) {
      if (this.i > 0) {
        this.showdialog = true;
        this.planningSheetTab = 1;
      } else if (this.i == 0) {
        if (tab != 0) {
          this.$store.dispatch("setPlanningSheetTab", Number(tab));
          this.planningSheetTab = this.createPlanningSheetTab;
        }
        if (tab == 2) {
          this.planningSheetTab = this.createPlanningSheetTab;
          this.getProjectionItemsList();
        }
      }
    },
    goAllPlanningSheets() {
      this.resetProjectionItemSelected();
      this.$router.push({ name: "View Current Sheets" });
    },
    // To Get Jobsite List Dropdown data
    async getJobSiteList() {
      this.isJobsiteLoading = true;
      try {
        let response = await smsServiceNew.getJobsiteList(
          this.smsCustomerLinkingId
        );
        if (response) {
          this.jobSiteList = response.data.sort((a, b) =>
            a.description.localeCompare(b.description)
          );
        } else {
          this.jobSiteList = [];
        }
        this.isJobsiteLoading = false;
      } catch (err) {
        this.isJobsiteLoading = false;

        console.log(err);
      }
    },
    onJobSiteInput() {
      this.i = this.i + 1;
      if (
        this.planningSheetObject.projectionJobSite &&
        this.planningSheetObject.projectionJobSite.jobNumber
      ) {
        this.projectionJobNo = this.planningSheetObject.projectionJobNo =
          this.planningSheetObject.projectionJobSite.jobNumber;
      } else {
        this.planningSheetObject.projectionJobNo = "";
      }
    },
    // To Get Approvers List Dropdown data
    async getApprovers() {
      this.isApproversLoading = true;
      try {
        let response = await smsServiceNew.getApproversList();
        if (response) {
          let approversList = [];
          approversList = response.data.map((d) => ({
            ...d,
            contactName:
              d.customerUserNameLast + ", " + d.customerUserNameFirst,
          }));
          this.approversList = approversList;
        } else {
          this.approversList = [];
        }
        this.isApproversLoading = false;
      } catch (err) {
        this.isApproversLoading = false;

        console.log(err);
      }
    },
    // To Get Contacts dropdown data
    async getContacts() {
      this.isContactsLoading = true;
      let tempProjecID =
        this.storeProjectionID != "" && this.storeProjectionID != null
          ? this.storeProjectionID
          : 0;
      try {
        let response = await smsServiceNew.getContactsList(
          this.smsUserId,
          this.smsBirchLinkingId,
          tempProjecID
        );

        if (response.data) {
          this.conactsList = response.data.map((d) => ({
            ...d,
            contactName:
              d.customerUserNameLast + ", " + d.customerUserNameFirst,
          }));
          this.selectedContact = this.conactsList
            .filter((a) => a.isSelected)
            .map((s) => s.birchUserID);
          this.isContactsLoading = false;
        } else {
          this.conactsList = [];
          this.isContactsLoading = false;
        }
      } catch (err) {
        this.isContactsLoading = false;

        console.log(err);
      }
    },
    // Create & Save New Planning Sheet
    async savePlanningSheetDetails(isFromCreateDialog = false) {
      this.isSaveBtn = true;
      this.i = 0;

      let payloadNew = {
        projectionName: this.planningSheetObject.projectionName,
        projectionLocation: this.planningSheetObject.projectionLocation,
        projectionStartDate: this.planningSheetObject.projectionStartDate,
        projectionEndDate: this.planningSheetObject.projectionEndDate,
        projectionJobComments: this.planningSheetObject.projectionJobComments,
        birchUserID: this.$store.getters.id,
        isDeleted: false,
        projectionJobNo: this.planningSheetObject.projectionJobNo,
        projectionJobSite:
          this.jobSiteRadioInput == "1"
            ? this.planningSheetObject.projectionJobSite.description
              ? this.planningSheetObject.projectionJobSite.description
              : this.planningSheetObject.projectionJobSite
            : this.newJobSite,
        projectionPONo: this.planningSheetObject.projectionPONo,
        projectionJobSiteNo:
          this.jobSiteRadioInput == "1"
            ? this.planningSheetObject.projectionJobSite.number
              ? String(this.planningSheetObject.projectionJobSite.number)
              : String(this.planningSheetObject.projectionJobSiteNo)
            : null,
        customerID: String(this.companyIdDropdown),
        approvers: this.selectedApprover,
        users: this.selectedContact,
        orderedBy: this.planningSheetObject.orderedBy,
        pickedUpBy: this.planningSheetObject.pickedUpBy,
        shift: String(this.planningSheetObject.shift),
        isDeliveryRequired: this.planningSheetObject.isDeliveryRequired
          ? this.planningSheetObject.isDeliveryRequired
          : false,
      };
      let response;
      let isUpdateFlag = false;
      try {
        if (this.storeReserveType == "") {
          response = await smsServiceNew.createNewPlanningSheet(
            this.smsUserId,
            payloadNew
          );
        } else if (this.storeReserveType == "Edit") {
          payloadNew["projectionId"] = this.planningSheetObject.projectionID;
          response = await smsServiceNew.updatePlanningSheet(payloadNew);
        } else if (this.storeReserveType == "Copy") {
          // TODO new endpoint yet to provide
          response = await smsServiceNew.copyProjectionSheet(
            this.copyProjectionId,
            payloadNew
          );
        }
        if (response && response.isSuccess && response.data) {
          this.isSaveBtn = false;
          if (this.storeReserveType == "") {
            this.$toast.success("New planning sheet data created successfully");
            this.$store.dispatch("setStoreReserveType", "Edit");
          } else if (this.storeReserveType == "Edit") {
            isUpdateFlag = true;
            this.$toast.success("Planning sheet data updated successfully");
          } else if (this.storeReserveType == "Copy") {
            this.copyProjectionId = "";
            this.$toast.success(
              "Copy of planning sheet data created successfully"
            );
          }
          // Navigate to Items tab after planning sheet creation
          if (isUpdateFlag != true) {
            this.$store.dispatch("setPlanningSheetTab", 2);
            this.planningSheetTab = this.createPlanningSheetTab;
          }
          //Store post API response for other operations
          this.planningSheetDataResponse = JSON.parse(
            JSON.stringify(response.data)
          );
          this.$store.dispatch("setPlanningSheetObj", response.data);
          this.planningSheetDataResponse = this.planningSheetObj;
          this.planningSheetObject = { ...this.planningSheetObj };
          //Store api response ProjectionID
          this.$store.dispatch(
            "setStoreProjectionID",
            response.data.projectionID
          );
          if (isFromCreateDialog) {
            this.getMasterItemsList(false, false, true);
            this.createPlanningSheetDialog = false;
          } else {
            this.getMasterItemsList(false);
          }
        } else {
          this.isSaveBtn = false;
          this.$toast.error(response.systemMessage);
        }
      } catch (err) {
        console.log(err);
        this.isSaveBtn = false;
        this.$toast.error("Unable to process the request");
      }
    },
    async getAvailableApprovers() {
      this.isApproversLoading = true;
      try {
        let response = await smsServiceNew.getavailableApprovers(
          this.smsUserId,
          this.storeProjectionID,
          this.smsBirchLinkingId
        );
        if (response) {
          let selectedapproversList = [];
          selectedapproversList = response.data.map((d) => ({
            ...d,
            contactName:
              d.customerUserNameLast + ", " + d.customerUserNameFirst,
          }));
          this.selectedApprover = selectedapproversList
            .filter((a) => a.isSelected)
            .map((s) => s.userId);
          if (this.planningSheetTab == 3) {
            if (this.roles == "Admin" || this.roles == "Birch User") {
              this.isApprover = true;
            } else {
              if (this.selectedApprover.includes(this.$store.getters.id)) {
                this.isApprover = true;
              }
            }
          }

          this.selectedApprover.concat(selectedapproversList);
          if (this.planningSheetTab == 1 && this.storeReserveType == "Copy") {
            this.selectedApprover = [];
          }
        }
        this.isApproversLoading = false;
      } catch (err) {
        this.isApproversLoading = false;
        console.log(err);
      }
    },
    // Blank sheet form. Returns a fresh object per call so callers cannot end
    // up sharing one reference. NOTE: deliberately not the same shape as the
    // data() initial value, which uses shift / isDeliveryRequired where this
    // uses selectedShift / projectionItemDelivery.
    defaultPlanningSheetObject() {
      return {
        birchUserID: "",
        canDeletePlanningSheet: "",
        canLockPlanningSheet: "",
        projectionCreatorName: "",
        projectionCreatorUserID: "",
        projectionEndDate: "",
        projectionID: "",
        projectionJobComments: "",
        projectionJobNo: "",
        projectionJobSite: {},
        projectionJobSiteNo: "",
        projectionLocation: "",
        projectionName: "",
        projectionPONo: "",
        projectionStartDate: "",
        projectionStatus: "",
        quantity: 1,
        selectedShift: 1,
        projectionItemDelivery: false,
        projectionItemOperatorCertification: false,
      };
    },
    clearSheetData() {
      this.planningSheetObject = this.defaultPlanningSheetObject();
      this.$refs.form.reset();
      this.$store.dispatch("setPlanningSheetObj", {});
      this.$store.dispatch("setStoreReserveType", "");
      this.$store.dispatch("setStoreProjectionID", "");
    },
    removeProjectionID() {
      this.$store.dispatch("setPlanningSheetTabPrev", 1);

      this.resetProjectionItemSelected();
      if (this.storeReserveType == "View") {
        this.planningSheetObject = this.planningSheetObj;
        if (this.planningSheetObject.projectionJobSiteNo != null) {
          this.jobSiteRadioInput = "1";
        } else {
          this.jobSiteRadioInput = "2";
          this.newJobSite = this.planningSheetObject.projectionJobSite;
        }
      }
    },
    setParentCategoryToStart() {
      this.categorylist.forEach((item, i) => {
        if (item.itemKey === this.parentKey) {
          this.categorylist.splice(i, 1);
          this.categorylist.unshift(item);
        }
      });
    },
    setParentCategorySearchToStart() {
      this.searchCategoryList.forEach((item, i) => {
        if (item.itemKey === this.parentKey) {
          this.searchCategoryList.splice(i, 1);
          this.searchCategoryList.unshift(item);
        }
      });
    },
    // Ascending by itemOrder; shared by the category / department / group
    // lists, which were each carrying their own copy of this comparator.
    sortByItemOrder(a, b) {
      return Number(a.itemOrder) > Number(b.itemOrder)
        ? 1
        : Number(b.itemOrder) > Number(a.itemOrder)
        ? -1
        : 0;
    },
    // Filter Items Process
    async getProjectionItemsList() {
      this.parentKey = "";
      this.newItemAddAfterReview = true;
      this.imgCategoryName = "";
      this.catTrue = false;
      this.depTrue = false;
      this.grpTrue = false;
      this.categoryNameList = [];
      this.depNameList = [];
      this.groupNameList = [];
      this.projectionItems = this.masterItems;
      this.showequipmentDetailsClick = false;
      this.categoryclick = false;
      this.groupclick = false;
      this.departmentclick = false;
      this.categorylistOriginal = [];
      this.categorylist = [];
      this.searchCategoryList = [];
      // BE-1088: the `if (this.equipmentGlobalSearch > 0)` branch that used to wrap
      // this was unreachable. equipmentGlobalSearch is an array, and comparing an
      // array to a number stringifies it first, so `[{...}] > 0` evaluates
      // "[object Object]" > 0 -> NaN > 0 -> always false. The else body below is
      // what has always run. The correct `.length > 0` idiom elsewhere in this file
      // is deliberately left alone.
      this.addSearchTerm = "";
      this.searchTermChips = [];
      this.hideAllCategoryBtn = false;
      this.categorylist = utils.dedupeByCategoryNbr(
        this.projectionItems
          .filter((e) => e.defaultCatItemKeyInd)
          .sort(this.sortByItemOrder)
      );
      this.searchCategoryList = utils.dedupeByCategoryNbr(
        this.projectionItems
          .filter((e) => e.defaultCatItemKeyInd)
          .sort(this.sortByItemOrder)
      );
      this.categorylistOriginal = this.categorylist;
    },

    //Click of Each Image category
    categoryClick(item) {
      this.parentKey = item.itemKey;
      this.imgCategoryName = "";
      this.equipmentGlobalSearch = [];
      this.categorylist = [];
      this.searchCategoryList = [];
      this.categorylist = utils.dedupeByDepartmentNbr(
        this.projectionItems
          .filter(
            (e) => e.categoryNbr == item.categoryNbr && e.defaultDeptItemKeyInd
          )
          .sort(this.sortByItemOrder)
      );
      this.searchCategoryList = utils.dedupeByDepartmentNbr(
        this.projectionItems
          .filter(
            (e) => e.categoryNbr == item.categoryNbr && e.defaultDeptItemKeyInd
          )
          .sort(this.sortByItemOrder)
      );
      if (this.parentKey) {
        this.setParentCategoryToStart();
        this.setParentCategorySearchToStart();
      }
      this.categoryclick = true;
      this.imgCategoryName =
        item.hierarchyTypNm.toLowerCase() == "rental"
          ? "Rental Departments"
          : "Sales Departments";
      this.categoryNameList = [];
      this.depNameList = [];
      this.groupNameList = [];
      if (this.categoryclick) {
        this.catTrue = true;
        this.depTrue = false;
        this.grpTrue = false;
        this.categoryNameList.push(item);
      }
      this.resetItemSettingsToDefault();
    },
    departmentClick(item) {
      this.parentKey = item.itemKey;
      this.imgCategoryName = "";
      this.equipmentGlobalSearch = [];
      // Narrow to the department BEFORE deduping by group name. Deduping the
      // whole catalog first collapsed a group name used under two departments
      // to a single row, so whichever department lost showed no tile for it at
      // all -- e.g. "Pole Saw, 525PT5S Telescopic" vanished from Sales >
      // Husqvarna because the Lawn & Garden row won.
      this.categorylist = utils.dedupeBy(
        this.projectionItems
          .filter((e) => e.departmentNbr == item.departmentNbr)
          .sort(this.sortByItemOrder),
        (e) => e.itemGroupNm
      );
      // Separate array instance -- setParentCategory*ToStart splice each in place.
      this.searchCategoryList = [...this.categorylist];
      if (this.parentKey) {
        this.setParentCategoryToStart();
        this.setParentCategorySearchToStart();
      }
      this.categoryclick = false;
      this.groupclick = false;
      this.departmentclick = true;
      this.depNameList = [];
      this.groupNameList = [];
      if (this.departmentclick) {
        this.catTrue = false;
        this.depTrue = true;
        this.grpTrue = false;
        this.depNameList.push(item);
      }
      this.showequipmentDetailsClick = false;
      this.imgCategoryName =
        item.hierarchyTypNm.toLowerCase() == "rental"
          ? "Rental Groups"
          : "Sales Groups";
      this.resetItemSettingsToDefault();
    },
    groupClick(item) {
      this.parentKey = item.itemKey;
      this.equipmentGlobalSearch = [];
      this.categorylist = [];
      this.searchCategoryList = [];
      // Scope to the department as well as the group name -- a group name used
      // under two departments would otherwise list both departments' items
      // under either tile. No-op for the groups whose name is unique.
      this.categorylist = this.projectionItems
        .filter(
          (e) =>
            e.itemGroupNm == item.itemGroupNm &&
            e.departmentNbr == item.departmentNbr
        )
        .sort(this.sortByItemOrder);
      this.searchCategoryList = this.projectionItems
        .filter(
          (e) =>
            e.itemGroupNm == item.itemGroupNm &&
            e.departmentNbr == item.departmentNbr
        )
        .sort(this.sortByItemOrder);
      if (this.parentKey) {
        this.setParentCategoryToStart();
        this.setParentCategorySearchToStart();
      }
      this.groupclick = true;
      this.groupNameList = [];
      if (this.groupclick) {
        this.catTrue = false;
        this.depTrue = false;
        this.grpTrue = true;
        this.groupNameList.push(item);
      }
      this.categoryclick = false;
      this.departmentclick = false;
      this.showequipmentDetailsClick = false;
      this.imgCategoryName = "Equipment";
      this.resetItemSettingsToDefault();
    },
    async showequipmentDetails(item, isGetSuggestions) {
      this.equipmentDetailsobj = item;
      let itemKey = item.itemKey;
      this.groupclick = false;
      this.categoryclick = false;
      this.departmentclick = false;
      this.showequipmentDetailsClick = true;
      if (!this.newItemAddAfterReview) {
        this.getReviewSheetList();
      }
      if (this.equipmentGlobalSearch.length > 0) {
        this.grpTrue = true;
        this.categoryNameList.push(item);
        this.depNameList.push(item);
        this.groupNameList.push(item);
        this.hideAllCategoryBtn = false;
        this.searchTermChips = [];
        this.addSearchTerm = "";
      }
      try {
        this.SuggestedItems = [];
        this.sugLoading = true;
        let response = await smsServiceNew.getSuggest(itemKey);
        if (response && response.isSuccess && response.data) {
          this.SuggestedItems = response.data.map((x, index) => ({
            ...x,
            sno: index + 1,
            isSugAddCheck: false,
            sugItemQty: "",
          }));
          if (isGetSuggestions) {
            this.getSuggestedItemsById();
          } else {
            this.sugLoading = false;
          }
        } else {
          this.SuggestedItems = [];
          this.sugLoading = false;
        }
      } catch (err) {
        this.sugLoading = false;
        console.log(err);
      }
    },
    //Click of left menu category titles
    categoryLeftMenuTitleClick(item) {
      this.parentKey = item.itemKey;
      this.imgCategoryName = "";
      this.groupclick = false;
      this.departmentclick = false;
      this.showequipmentDetailsClick = false;

      this.categorylist = [];
      this.searchCategoryList = [];
      // BE-1088: unreachable `if (this.equipmentGlobalSearch > 0)` wrapper removed
      // here too — same array-compared-to-number bug as in getProjectionItemsList.
      this.addSearchTerm = "";
      this.searchTermChips = [];
      this.hideAllCategoryBtn = false;
      const departments = utils.dedupeByDepartmentNbr(
        this.projectionItems
          .filter(
            (e) => e.categoryNbr == item.categoryNbr && e.defaultDeptItemKeyInd
          )
          .sort(this.sortByItemOrder)
      );
      this.categorylist = departments;
      // searchCategoryList backs the department search box; leaving it empty
      // here made categorySearch/clearCatSearch blank the tile grid. Separate
      // array instance -- setParentCategory*ToStart splices each in place.
      this.searchCategoryList = [...departments];
      if (this.parentKey) {
        this.setParentCategoryToStart();
        this.setParentCategorySearchToStart();
      }

      this.categoryclick = true;
      this.categoryNameList = [];
      this.depNameList = [];
      this.groupNameList = [];
      this.catTrue = true;
      this.depTrue = false;
      this.grpTrue = false;
      this.categoryNameList.push(item);
      this.imgCategoryName =
        item.hierarchyTypNm.toLowerCase() == "rental"
          ? "Rental Departments"
          : "Sales Departments";
      this.resetItemSettingsToDefault();
    },
    updateItem() {
      this.itemsPostConfirmDialog = true;
      this.putItem();
    },
    openConfirmDialog() {
      this.itemsPostConfirmDialog = true;
      this.postItems();
    },
    // Item payload shared by the add (post) and update (put) flows. putItem
    // prepends projectionItemID; the remaining fields are identical.
    buildProjectionItemPayload() {
      return {
        projectionItemEquipment: this.equipmentDetailsobj.itemKey,
        projectionItemQuantity: Number(this.planningSheetItemObject.quantity),
        projectionItemShifts: Number(
          this.planningSheetItemObject.selectedShift
            ? this.planningSheetItemObject.selectedShift
            : 1
        ),
        projectionItemStartDate:
          this.planningSheetItemObject.projectionStartDate,
        projectionItemEndDate: this.planningSheetItemObject.projectionEndDate,
        projectionItemOperatorCertification: this.planningSheetItemObject
          .projectionItemOperatorCertification
          ? this.planningSheetItemObject.projectionItemOperatorCertification
          : false,
        projectionItemDelivery: this.planningSheetItemObject
          .projectionItemDelivery
          ? this.planningSheetItemObject.projectionItemDelivery
          : false,
        isDeleted: false,
        isOptionalItem: false,
        salePrice: this.equipmentDetailsobj.salePrice,
        projectionItemCategory:
          this.planningSheetItemObject.projectionItemCategory,
        hierarchyTypNm: this.equipmentDetailsobj.hierarchyTypNm,
        projectionItemCategoryDescription:
          this.planningSheetItemObject.projectionItemCategoryDescription,
        projectionItemEquipmentDescription: "",
        poNo: this.planningSheetItemObject.projectionPONo,
        jobNo: this.planningSheetItemObject.projectionJobNo,
        pickedUpBy: this.planningSheetItemObject.pickedUpBy,
        orderedBy: this.planningSheetItemObject.orderedBy,
      };
    },
    async postItems() {
      this.addItemPlanningSheet = true;
      let item = this.buildProjectionItemPayload();

      this.postSuggestedItems(item);
    },
    async putItem() {
      this.addItemPlanningSheet = true;
      let item = {
        projectionItemID: this.storeProjectionItemID,
        ...this.buildProjectionItemPayload(),
      };
      this.putSuggestedItems(item);
    },
    addAnotherItem() {
      this.itemsPostConfirmDialog = false;
      this.getProjectionItemsList();
    },
    goToReviewPlanningSheet() {
      // Navigate to Review tab after items added to sheet
      this.$store.dispatch("setPlanningSheetTab", 3);
      this.planningSheetTab = this.createPlanningSheetTab;
      this.resetProjectionItemSelected();
      this.getReviewSheetList();
    },
    newPlanningSheet() {
      this.createPlanningSheetDialog = true;
      this.jobSiteRadioInput = "1";
      this.newJobSite = "";
      this.selectedContact = [];
      this.selectedApprover = [];
      this.selectedItemAtTimeOfCreation = this.equipmentDetailsobj.itemKey;
      this.planningSheetObject.projectionJobNo = this.planningSheetItemObject
        .projectionJobNo
        ? this.planningSheetItemObject.projectionJobNo
        : "";
      this.planningSheetObject.projectionPONo = this.planningSheetItemObject
        .projectionPONo
        ? this.planningSheetItemObject.projectionPONo
        : "";
      this.planningSheetObject.orderedBy = this.planningSheetItemObject
        .orderedBy
        ? this.planningSheetItemObject.orderedBy
        : "";
      this.planningSheetObject.pickedUpBy = this.planningSheetItemObject
        .pickedUpBy
        ? this.planningSheetItemObject.pickedUpBy
        : "";
      this.planningSheetObject.isDeliveryRequired = this.planningSheetItemObject
        .projectionItemDelivery
        ? this.planningSheetItemObject.projectionItemDelivery
        : false;
      this.planningSheetObject.projectionStartDate = this
        .planningSheetItemObject.projectionStartDate
        ? this.planningSheetItemObject.projectionStartDate
        : "";
      this.planningSheetObject.projectionEndDate = this.planningSheetItemObject
        .projectionEndDate
        ? this.planningSheetItemObject.projectionEndDate
        : "";
      this.planningSheetObject.shift = this.planningSheetItemObject
        .selectedShift
        ? this.planningSheetItemObject.selectedShift
        : 1;
    },
    closeCreatePlanningSheet() {
      this.createPlanningSheetDialog = false;
      this.refreshJobSiteRadio = false;
      this.$refs.createForm.reset();
      this.jobSiteRadioInput = "1";
      this.newJobSite = "";
      setTimeout(() => (this.refreshJobSiteRadio = true), 1000);
      this.planningSheetObject = this.defaultPlanningSheetObject();
      this.selectedContact = [];
      this.selectedApprover = [];
      this.i = 0;
    },
    callReviewTab() {
      this.resetProjectionItemSelected();
      this.getReviewSheetList();
    },
    //Get Review Obj in copy flow
    async getReviewObjDataInCopyFlow() {
      this.getPlanningSheetById();
    },
    // not using in new // getting all data for review
    async getReviewObjDataInEditFlow() {
      this.getPlanningSheetById();
    },
    async getPlanningSheetById() {
      this.copyProjectionId = "";
      this.planningSheetObject = {};
      this.reviewSheetList = [];
      this.expanded = [];
      this.isReviewDataLoading = true;
      try {
        let response = await smsServiceNew.getPlanningSheetById(
          this.smsUserId,
          this.storeProjectionID
        );
        if (response && response.data) {
          this.planningSheetObject = response.data;
          this.$store.dispatch("setPlanningSheetObj", this.planningSheetObject);
          if (this.planningSheetTab == 3) {
            this.reviewSheetList = JSON.parse(
              JSON.stringify(response.data.birchProjectionItems)
            );
            //show all items as expanded
            this.reviewSheetList.map((item) => {
              this.expanded.push(item);
            });
            this.calcTotalCost();
          }

          this.getAvailableApprovers();
          this.getContacts();

          if (response.data.projectionJobSiteNo != null) {
            this.jobSiteRadioInput = "1";
          } else {
            this.jobSiteRadioInput = "2";
            this.newJobSite = response.data.projectionJobSite;
          }
          this.planningSheetObject.shift = this.planningSheetObject.shift
            ? Number(this.planningSheetObject.shift)
            : 1;
          if (this.planningSheetTab == 1 && this.storeReserveType == "Copy") {
            this.copyProjectionId = this.planningSheetObject.projectionID;
            this.$store.dispatch("setStoreProjectionID", "");
            this.planningSheetObject.projectionID = "";
            this.planningSheetObject.projectionName = "";
            this.planningSheetObject.projectionStartDate = "";
            this.planningSheetObject.projectionEndDate = "";
            this.planningSheetObject.orderedBy = "";
            this.planningSheetObject.pickedUpBy = "";
            this.planningSheetObject.quantity = "";
            this.planningSheetObject.shift = 1;
            this.selectedApprover = [];
            if (this.planningSheetObject.projectionJobSiteNo != null) {
              this.jobSiteRadioInput = "1";
            } else {
              this.jobSiteRadioInput = "2";
              this.newJobSite = this.planningSheetObject.projectionJobSite;
            }
          }
          if (this.planningSheetTab == 3) {
            this.getMasterItemsList(false, true);
          } else {
            this.isReviewDataLoading = false;
          }
        } else {
          this.$toast.error(response.systemMessage);
          this.isReviewDataLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isReviewDataLoading = false;
      }
    },
    //Get Review table data
    async getReviewSheetList() {
      this.isApprover = false;
      this.getPlanningSheetById();
    },
    routeToItems() {
      if (this.i > 0) {
        this.showdialog = true;
        this.planningSheetTab = 1;
        this.$store.dispatch("setPlanningSheetTab", 1);
      } else if (this.i == 0) {
        this.newItemAddAfterReview = true;
        this.$store.dispatch("setPlanningSheetTab", 2);
        this.$store.dispatch("setStoreProjectionItemEquipment", "");
        this.planningSheetTab = this.createPlanningSheetTab;
        this.getMasterItemsList(false);
      }
    },
    async refreshRates() {
      this.isRefreshBtn = true;
      try {
        let response = await smsServiceNew.refreshRates(this.storeProjectionID);
        if (response) {
          this.isRefreshBtn = false;
          this.getReviewSheetList();
        } else {
          this.isRefreshBtn = false;
        }
      } catch (err) {
        this.isRefreshBtn = false;
        console.log(err);
      }
    },
    downloadReviewTableExcel() {
      let th = this;
      let formatDateUS = "MM/DD/YYYY";

      // Replace any of the characters : \ / ? * [ ] with _

      let excelSheetname = this.planningSheetObject.projectionName
        .replace(/[:\\/?*]/g, "_") // Replace core invalid characters
        .replace(/\[/g, "_") // Replace [
        .replace(/\]/g, "_"); // Replace ]

      this.excelHeader.push([excelSheetname]);
      this.excelHeader.push([]);
      this.excelHeader.push([
        "Date Modified",
        "Equipment Name",
        "Equipment Number",
        "Start Date",
        "End Date",
        "Qty",
        "Job#",
        "Shifts",
        "Cert. Needed",
        "Delivery",
        "PO#",
        "Picked Up By",
        "Ordered By",
        "Additional Notes 1",
        "Additional Notes 2",
      ]);
      let finalReviewList = [];
      for (var r = 0; r < this.reviewSheetList.length; r++) {
        finalReviewList.push(
          JSON.parse(JSON.stringify(this.reviewSheetList[r]))
        );
        for (
          var s = 0;
          s < this.reviewSheetList[r].suggestedItems.length;
          s++
        ) {
          finalReviewList.push(
            JSON.parse(
              JSON.stringify(this.reviewSheetList[r].suggestedItems[s])
            )
          );
        }
      }
      let tempExcel = finalReviewList.map(function (item) {
        return item;
      });
      for (var k = 0; k < tempExcel.length; k++) {
        if (tempExcel[k].projectionItemRevisionDate) {
          tempExcel[k].projectionItemRevisionDate = moment(
            tempExcel[k].projectionItemRevisionDate
          )
            .local()
            .format(formatDateUS);
          tempExcel[k].projectionItemStartDate = moment(
            tempExcel[k].projectionItemStartDate
          )
            .local()
            .format(formatDateUS);
          tempExcel[k].projectionItemEndDate = moment(
            tempExcel[k].projectionItemEndDate
          )
            .local()
            .format(formatDateUS);
        }

        tempExcel[k].projectionItemDelivery = tempExcel[k]
          .projectionItemDelivery
          ? "Yes"
          : "No";
        if (tempExcel[k].salePrice || tempExcel[k].salePrice === 0) {
          tempExcel[k].salePrice =
            tempExcel[k].salePrice > 0 && tempExcel[k].hierarchyTypNm === "NEW"
              ? Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(tempExcel[k].salePrice)
              : "";
        }
        if (
          tempExcel[k].projectionItemEstCost ||
          tempExcel[k].projectionItemEstCost === 0
        ) {
          tempExcel[k].projectionItemEstCost =
            tempExcel[k].projectionItemShifts === 1 ||
            (tempExcel[k].projectionItemShifts !== 1 &&
              !tempExcel[k].hidePriceRate)
              ? Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(tempExcel[k].projectionItemEstCost)
              : "";
        }
        if (tempExcel[k].monthlyRate || tempExcel[k].monthlyRate === 0) {
          tempExcel[k].monthlyRate =
            tempExcel[k].projectionItemEquipment === "OTHER"
              ? Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(tempExcel[k].projectionItemCustomRateMonth)
              : tempExcel[k].hierarchyTypNm !== "NEW" &&
                tempExcel[k].projectionItemShifts === 1
              ? Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(tempExcel[k].monthlyRate)
              : tempExcel[k].hierarchyTypNm !== "NEW" &&
                tempExcel[k].projectionItemShifts !== 1 &&
                tempExcel[k].hidePriceRate === false
              ? Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(tempExcel[k].monthlyRate)
              : tempExcel[k].hierarchyTypNm !== "NEW" &&
                tempExcel[k].projectionItemShifts !== 1 &&
                tempExcel[k].hidePriceRate === true
              ? "TBD"
              : "";
        }
        if (tempExcel[k].weeklyRate || tempExcel[k].weeklyRate === 0) {
          tempExcel[k].weeklyRate =
            tempExcel[k].projectionItemEquipment === "OTHER"
              ? Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(tempExcel[k].projectionItemCustomRateWeek)
              : tempExcel[k].hierarchyTypNm !== "NEW" &&
                tempExcel[k].projectionItemShifts === 1
              ? Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(tempExcel[k].weeklyRate)
              : tempExcel[k].hierarchyTypNm !== "NEW" &&
                tempExcel[k].projectionItemShifts !== 1 &&
                tempExcel[k].hidePriceRate === false
              ? Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(tempExcel[k].weeklyRate)
              : tempExcel[k].hierarchyTypNm !== "NEW" &&
                tempExcel[k].projectionItemShifts !== 1 &&
                tempExcel[k].hidePriceRate === true
              ? "TBD"
              : "";
        }
        if (tempExcel[k].dailyRate || tempExcel[k].dailyRate === 0) {
          tempExcel[k].dailyRate =
            tempExcel[k].projectionItemEquipment === "OTHER"
              ? Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(tempExcel[k].projectionItemCustomRateDay)
              : tempExcel[k].hierarchyTypNm !== "NEW" &&
                tempExcel[k].projectionItemShifts === 1
              ? Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(tempExcel[k].dailyRate)
              : tempExcel[k].hierarchyTypNm !== "NEW" &&
                tempExcel[k].projectionItemShifts !== 1 &&
                tempExcel[k].hidePriceRate === false
              ? Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(tempExcel[k].dailyRate)
              : tempExcel[k].hierarchyTypNm !== "NEW" &&
                tempExcel[k].projectionItemShifts !== 1 &&
                tempExcel[k].hidePriceRate === true
              ? "TBD"
              : "";
        }
        tempExcel[k].projectionItemShifts =
          tempExcel[k].projectionItemShifts == 0
            ? "Standard"
            : tempExcel[k].projectionItemShifts == 1
            ? "Single"
            : tempExcel[k].projectionItemShifts == 2
            ? "Double"
            : tempExcel[k].projectionItemShifts == 3
            ? "Triple"
            : "";
      }
      tempExcel = finalReviewList.map(function (item) {
        delete item.projectionID;
        delete item.projectionItemID;
        delete item.projectionItemContractRateDay;
        delete item.projectionItemContractRateMonth;
        delete item.projectionItemContractRateWeek;
        delete item.projectionItemCustomRateDay;
        delete item.projectionItemCustomRateMonth;
        delete item.projectionItemCustomRateWeek;
        delete item.projectionItemCategory;
        delete item.projectionItemCategoryDescription;
        delete item.hierarchyTypNm;
        delete item.hidePriceRate;
        delete item.projectionItemListRateDay;
        delete item.projectionItemListRateMonth;
        delete item.projectionItemListRateWeek;
        delete item.isDeleted;
        delete item.isOptionalItem;
        !th.smsUserPermissions ||
        (th.smsUserPermissions &&
          !th.smsUserPermissions.seeRatesOnPlanningSheets)
          ? delete item.dailyRate
          : "";
        !th.smsUserPermissions ||
        (th.smsUserPermissions &&
          !th.smsUserPermissions.seeRatesOnPlanningSheets)
          ? delete item.monthlyRate
          : "";
        !th.smsUserPermissions ||
        (th.smsUserPermissions &&
          !th.smsUserPermissions.seeRatesOnPlanningSheets)
          ? delete item.weeklyRate
          : "";
        !th.smsUserPermissions ||
        (th.smsUserPermissions &&
          !th.smsUserPermissions.seeRatesOnPlanningSheets)
          ? delete item.salePrice
          : "";
        !th.smsUserPermissions ||
        (th.smsUserPermissions &&
          !th.smsUserPermissions.seeRatesOnPlanningSheets)
          ? delete item.projectionItemEstCost
          : "";
        delete item.projectionItemMarketRateDay;
        delete item.projectionItemMarketRateWeek;
        delete item.projectionItemMarketRateMonth;
        th.roles == "Customer" ? delete item.additionalNotes1 : "";
        th.roles == "Customer" ? delete item.additionalNotes2 : "";

        item.parentProjectionItemID ? delete item.parentProjectionItemID : "";
        return item;
      });

      if (
        this.smsUserPermissions &&
        this.smsUserPermissions.seeRatesOnPlanningSheets
      ) {
        this.excelHeader[2].splice(
          6,
          0,
          ...["Daily Rate", "Weekly Rate", "Monthly", "Sale Price", "Est Cost"]
        );
      }
      if (this.roles == "Customer") {
        if (this.excelHeader[2].includes("Additional Notes 1")) {
          this.excelHeader[2] = this.excelHeader[2].filter(
            (e) => e != "Additional Notes 1"
          );
        }
        if (this.excelHeader[2].includes("Additional Notes 2")) {
          this.excelHeader[2] = this.excelHeader[2].filter(
            (e) => e != "Additional Notes 2"
          );
        }
      }
      // Data starts on the row after the header rows pushed above.
      let datarow = "A" + (this.excelHeader.length + 1);
      var ws = XLSX.utils.aoa_to_sheet(this.excelHeader);
      XLSX.utils.sheet_add_json(ws, tempExcel, {
        header:
          this.smsUserPermissions &&
          this.smsUserPermissions.seeRatesOnPlanningSheets &&
          this.roles == "Customer"
            ? [
                "projectionItemRevisionDate",
                "projectionItemEquipmentDescription",
                "projectionItemEquipment",
                "projectionItemStartDate",
                "projectionItemEndDate",
                "projectionItemQuantity",
                "dailyRate",
                "weeklyRate",
                "monthlyRate",
                "salePrice",
                "projectionItemEstCost",
                "jobNo",
                "projectionItemShifts",
                "projectionItemOperatorCertification",
                "projectionItemDelivery",
                "poNo",
                "pickedUpBy",
                "orderedBy",
              ]
            : this.smsUserPermissions &&
              this.smsUserPermissions.seeRatesOnPlanningSheets &&
              this.roles != "Customer"
            ? [
                "projectionItemRevisionDate",
                "projectionItemEquipmentDescription",
                "projectionItemEquipment",
                "projectionItemStartDate",
                "projectionItemEndDate",
                "projectionItemQuantity",
                "dailyRate",
                "weeklyRate",
                "monthlyRate",
                "salePrice",
                "projectionItemEstCost",
                "jobNo",
                "projectionItemShifts",
                "projectionItemOperatorCertification",
                "projectionItemDelivery",
                "poNo",
                "pickedUpBy",
                "orderedBy",
                "additionalNotes1",
                "additionalNotes2",
              ]
            : [
                "projectionItemRevisionDate",
                "projectionItemEquipmentDescription",
                "projectionItemEquipment",
                "projectionItemStartDate",
                "projectionItemEndDate",
                "projectionItemQuantity",
                "jobNo",
                "projectionItemShifts",
                "projectionItemOperatorCertification",
                "projectionItemDelivery",
                "poNo",
                "pickedUpBy",
                "orderedBy",
                "additionalNotes1",
                "additionalNotes2",
              ],
        skipHeader: true,
        origin: datarow,
      });
      var wb = XLSX.utils.book_new();
      let excelName = "";

      if (excelSheetname.length > 31) {
        excelName = "Projection Items";
      } else {
        excelName = excelSheetname;
      }
      XLSX.utils.book_append_sheet(wb, ws, excelName);
      this.excelHeader = [];

      XLSX.writeFile(wb, excelSheetname + ".xlsx");
    },
    // finalSubmitOfItems
    async finalSubmitOfItems() {
      this.isItemsSubmit = true;
      try {
        let response = await smsServiceNew.finalSubmitOfItems(
          this.storeProjectionID
        );
        if (response && response.isSuccess) {
          this.$toast.success("Items submitted successfully");
          this.getReviewSheetList();
          this.$router.push({ name: "View Current Sheets" });
          this.isItemsSubmit = false;
        } else {
          this.$toast.error("Unable to submit");
          this.isItemsSubmit = false;
        }
      } catch (err) {
        this.isItemsSubmit = false;
        this.$toast.success("Unable to submit the items");
        console.log(err);
      }
    },
    // Open Delete Review Page Table Dialog
    openReviewDeleteDialog(item) {
      this.reviewDeleteObj = item;
      this.$store.dispatch(
        "setStoreProjectionID",
        this.reviewDeleteObj.projectionID
      );
      this.$store.dispatch(
        "setStoreProjectionItemEquipment",
        this.reviewDeleteObj.projectionItemEquipment
      );
      this.$store.dispatch(
        "setStoreProjectionItemID",
        this.reviewDeleteObj.projectionItemID
      );
      this.$store.dispatch(
        "setSuggestedProjectionItemID",
        this.reviewDeleteObj.projectionItemID
      );
      this.reviewDeleteDialog = true;
    },
    closeReviewDeleteDialog() {
      this.reviewDeleteDialog = false;
      this.resetProjectionItemSelected();
    },
    //Delete Review Page Table Record
    async deleteReviewTableRecord() {
      this.isReviewRecordDelete = true;
      try {
        let response = await smsServiceNew.deleteReviewSheetRecord(
          this.storeProjectionID,
          this.storeProjectionItemID
        );
        if (response && response.isSuccess) {
          this.isReviewRecordDelete = false;
          this.$toast.success("Item deleted successfully");
          this.closeReviewDeleteDialog();
          this.getReviewSheetList();
        } else {
          this.isReviewRecordDelete = false;
          this.$toast.error(response.systemMessage);
        }
      } catch (err) {
        console.log(err);
        this.isReviewRecordDelete = false;
        this.$toast.error("Unable to delete");
      }
    },
    openCustomRatesDialog(item) {
      this.customRateItemObj = JSON.parse(JSON.stringify(item));

      this.customRatesDialog = true;
    },
    closeRatesDialog() {
      this.customRatesDialog = false;
    },
    async updateCustomRates() {
      this.isUpdateCustomRates = true;
      let payload = {
        projectionID: this.customRateItemObj.projectionID,
        projectionItemRevisionDate:
          this.customRateItemObj.projectionItemRevisionDate,
        projectionItemEquipment: this.customRateItemObj.projectionItemEquipment,
        projectionItemQuantity: this.customRateItemObj.projectionItemQuantity,
        projectionItemShifts: this.customRateItemObj.projectionItemShifts,
        projectionItemStartDate: this.customRateItemObj.projectionItemStartDate,
        projectionItemEndDate: this.customRateItemObj.projectionItemEndDate,
        projectionItemOperatorCertification:
          this.customRateItemObj.projectionItemOperatorCertification,
        projectionItemDelivery: this.customRateItemObj.projectionItemDelivery,
        projectionItemContractRateDay:
          this.customRateItemObj.projectionItemContractRateDay,
        projectionItemContractRateWeek:
          this.customRateItemObj.projectionItemContractRateWeek,
        projectionItemContractRateMonth:
          this.customRateItemObj.projectionItemContractRateMonth,
        projectionItemJobSiteRateDay:
          this.customRateItemObj.projectionItemJobSiteRateDay,
        projectionItemJobSiteRateWeek:
          this.customRateItemObj.projectionItemJobSiteRateWeek,
        projectionItemJobSiteRateMonth:
          this.customRateItemObj.projectionItemJobSiteRateMonth,
        projectionItemCategory: this.customRateItemObj.projectionItemCategory,
        projectionItemListRateDay:
          this.customRateItemObj.projectionItemListRateDay,
        projectionItemListRateWeek:
          this.customRateItemObj.projectionItemListRateWeek,
        projectionItemListRateMonth:
          this.customRateItemObj.projectionItemListRateMonth,
        projectionItemEquipmentDescription:
          this.customRateItemObj.projectionItemEquipmentDescription,
        projectionItemCategoryDescription:
          this.customRateItemObj.projectionItemCategoryDescription,
        projectionItemCustomRateDay:
          this.customRateItemObj.projectionItemCustomRateDay,
        projectionItemCustomRateWeek:
          this.customRateItemObj.projectionItemCustomRateWeek,
        projectionItemCustomRateMonth:
          this.customRateItemObj.projectionItemCustomRateMonth,
        isDeleted: this.customRateItemObj.isDeleted,
        projectionItemMarketRateDay:
          this.customRateItemObj.projectionItemMarketRateDay,
        projectionItemMarketRateWeek:
          this.customRateItemObj.projectionItemMarketRateWeek,
        projectionItemMarketRateMonth:
          this.customRateItemObj.projectionItemMarketRateMonth,
        poNo: this.customRateItemObj.poNo,
        jobNo: this.customRateItemObj.jobNo,
        pickedUpBy: this.customRateItemObj.pickedUpBy,
        orderedBy: this.customRateItemObj.orderedBy,
        parentProjectionItemID: this.customRateItemObj.parentProjectionItemID,
        isOptionalItem: this.customRateItemObj.isOptionalItem,
        salePrice: this.customRateItemObj.salePrice,
        hierarchyTypNm: this.customRateItemObj.hierarchyTypNm,
        hidePriceRate: this.customRateItemObj.hidePriceRate,
      };
      try {
        let response = await smsServiceNew.updateCustomRates(
          this.customRateItemObj.projectionItemID,
          payload
        );
        if (response && response.isSuccess) {
          this.isUpdateCustomRates = false;
          this.$toast.success("Custom rates updated successfully");
          this.closeRatesDialog();
          this.getReviewSheetList();
        } else {
          this.isUpdateCustomRates = false;
          this.$toast.error("Unable to update custom rates");
        }
      } catch (err) {
        console.log(err);
        this.isUpdateCustomRates = false;
        this.$toast.error("Unable to update custom rates");
      }
    },
    resetProjectionItemSelected() {
      this.$store.dispatch("setStoreProjectionItemEquipment", "");
      this.$store.dispatch("setStoreProjectionItemID", "");
      this.$store.dispatch("setSuggestedProjectionItemID", "");
    },
    resetItemSettingsToDefault() {
      this.planningSheetItemObject["quantity"] = 1;
      this.planningSheetItemObject.projectionJobNo =
        this.planningSheetObj.projectionJobNo;
      this.planningSheetItemObject.projectionPONo =
        this.planningSheetObj.projectionPONo;
      this.planningSheetItemObject.orderedBy = this.planningSheetObj.orderedBy;
      this.planningSheetItemObject.pickedUpBy =
        this.planningSheetObj.pickedUpBy;
      this.planningSheetItemObject.projectionItemDelivery =
        this.planningSheetObj.isDeliveryRequired;
      this.planningSheetItemObject.projectionStartDate = this.planningSheetObj
        .projectionStartDate
        ? moment(this.planningSheetObj.projectionStartDate).format("YYYY-MM-DD")
        : null;
      this.planningSheetItemObject.projectionEndDate = this.planningSheetObj
        .projectionEndDate
        ? moment(this.planningSheetObj.projectionEndDate).format("YYYY-MM-DD")
        : null;
      this.planningSheetItemObject.selectedShift = this.planningSheetObj.shift
        ? Number(this.planningSheetObj.shift)
        : 1;
      this.planningSheetItemObject.projectionItemOperatorCertification = false;
      this.planningSheetItemObject.projectionItemEquipmentDescription = "";
      this.resetProjectionItemSelected();
    },
    setItemSettings(editItem) {
      this.planningSheetItemObject["quantity"] =
        editItem["projectionItemQuantity"] != null
          ? editItem["projectionItemQuantity"]
          : 0;
      this.planningSheetItemObject.projectionJobNo =
        editItem.jobNo != null ? editItem.jobNo : "";
      this.planningSheetItemObject.projectionPONo =
        editItem.poNo != null ? editItem.poNo : "";
      this.planningSheetItemObject.orderedBy =
        editItem.orderedBy != null ? editItem.orderedBy : "";
      this.planningSheetItemObject.pickedUpBy =
        editItem.pickedUpBy != null ? editItem.pickedUpBy : "";
      this.planningSheetItemObject.projectionItemDelivery =
        editItem.projectionItemDelivery != null
          ? editItem.projectionItemDelivery
          : "";
      this.planningSheetItemObject.projectionStartDate =
        editItem.projectionItemStartDate.split("T")[0] != null
          ? editItem.projectionItemStartDate.split("T")[0]
          : "";
      this.planningSheetItemObject.projectionEndDate =
        editItem.projectionItemEndDate.split("T")[0] != null
          ? editItem.projectionItemEndDate.split("T")[0]
          : "";
      this.planningSheetItemObject.selectedShift =
        editItem.projectionItemShifts != null
          ? Number(editItem.projectionItemShifts)
          : 1;
      this.planningSheetItemObject.projectionItemOperatorCertification =
        editItem.projectionItemOperatorCertification != null
          ? editItem.projectionItemOperatorCertification
          : "";
      this.planningSheetItemObject.projectionItemEquipmentDescription =
        editItem.projectionItemEquipmentDescription != null
          ? editItem.projectionItemEquipmentDescription
          : "";
    },
    getItemInfoById(item, itemKey) {
      let editItem = item;
      this.planningSheetItemObject["quantity"] = 1;
      this.planningSheetItemObject.projectionJobNo = editItem.projectionJobNo
        ? editItem.projectionJobNo
        : "";
      this.planningSheetItemObject.projectionPONo = editItem.projectionPONo
        ? editItem.projectionPONo
        : "";
      this.planningSheetItemObject.orderedBy = editItem.orderedBy
        ? editItem.orderedBy
        : "";
      this.planningSheetItemObject.pickedUpBy = editItem.pickedUpBy
        ? editItem.pickedUpBy
        : "";
      this.planningSheetItemObject.projectionItemDelivery =
        editItem.isDeliveryRequired ? editItem.isDeliveryRequired : false;
      this.planningSheetItemObject.projectionStartDate =
        editItem.projectionStartDate.split("T")[0] != null
          ? editItem.projectionStartDate.split("T")[0]
          : "";
      this.planningSheetItemObject.projectionEndDate =
        editItem.projectionEndDate.split("T")[0] != null
          ? editItem.projectionEndDate.split("T")[0]
          : "";
      this.planningSheetItemObject.selectedShift = editItem.shift
        ? Number(editItem.shift)
        : 1;
      this.newItemAddAfterReview = false;
      let a = this.masterItems.filter((e) => e.itemKey == itemKey);
      this.getSuggestedItemsList(a[0].itemKey, false);
      this.equipmentDetailsobj = a[0];
      this.groupclick = false;
      this.categoryclick = false;
      this.departmentclick = false;
      this.showequipmentDetailsClick = true;
    },
    editReviewTableRecord(item) {
      let editItem = {};
      if (!item.parentProjectionItemID) {
        editItem = item;
      } else {
        let tempItem = this.reviewSheetList.filter(
          (e) => e.projectionItemID == item.parentProjectionItemID
        );
        editItem = tempItem[0];
      }
      this.setItemSettings(editItem);
      this.newItemAddAfterReview = false;
      this.$store.dispatch("setPlanningSheetTab", 2);
      this.planningSheetTab = this.createPlanningSheetTab;
      this.$store.dispatch("setStoreProjectionID", editItem.projectionID);
      this.$store.dispatch(
        "setStoreProjectionItemEquipment",
        editItem.projectionItemEquipment
      );
      this.$store.dispatch(
        "setStoreProjectionItemID",
        editItem.projectionItemID
      );
      this.$store.dispatch(
        "setSuggestedProjectionItemID",
        editItem.projectionItemID
      );
      let a = this.masterItems.filter(
        (e) => e.itemKey == this.storeProjectionItemEquipment
      );
      this.getSuggestedItemsList(a[0].itemKey, true);
      this.equipmentDetailsobj = a[0];
      this.getReviewSheetList();
      this.groupclick = false;
      this.categoryclick = false;
      this.departmentclick = false;
      this.showequipmentDetailsClick = true;
    },
    calcTotalCost() {
      this.estimatedCost = 0.0;
      for (var k = 0; k < this.reviewSheetList.length; k++) {
        if (
          this.reviewSheetList[k]["projectionItemShifts"] === 1 ||
          (this.reviewSheetList[k]["projectionItemShifts"] !== 1 &&
            this.reviewSheetList[k]["hidePriceRate"] === false)
        ) {
          this.estimatedCost +=
            this.reviewSheetList[k]["projectionItemEstCost"];
        }
        for (
          var s = 0;
          s < this.reviewSheetList[k].suggestedItems.length;
          s++
        ) {
          if (
            this.reviewSheetList[k].suggestedItems[s][
              "projectionItemShifts"
            ] === 1 ||
            (this.reviewSheetList[k].suggestedItems[s][
              "projectionItemShifts"
            ] !== 1 &&
              this.reviewSheetList[k].suggestedItems[s]["hidePriceRate"] ===
                false)
          ) {
            this.estimatedCost +=
              this.reviewSheetList[k].suggestedItems[s][
                "projectionItemEstCost"
              ];
          }
        }
      }
    },
    updateReviewEditDetails() {
      this.updateItem();
    },
    routetopurchase(key) {
      this.$router.push({
        name: "Purchase Quote Request",
        params: { itemKey: key },
      });
    },
    // Unlisted Equipment Functions
    openUnlistedEquipmentDialog() {
      this.unlistedEquipmentDialog = true;
      this.unlistedEquipmentType = "New Unlisted Equipment";
      this.resetItemSettingsToDefault();
    },
    editUnlistedEquipmentDialog(item) {
      this.$store.dispatch("setStoreProjectionID", item.projectionID);
      this.$store.dispatch("setStoreProjectionItemID", item.projectionItemID);
      this.unlistedEquipmentType = "Edit Unlisted Equipment";
      this.unlistedEquipmentDialog = true;
      this.setItemSettings(item);
    },
    updateUnlistedEquipment() {
      // TO DO
      this.saveUnlistedEquipment("Edit");
    },
    closeUnlistedEquipmentDialog() {
      this.unlistedEquipmentDialog = false;
      this.unlistedEquipmentType = "";
      this.resetItemSettingsToDefault();
    },
    async saveUnlistedEquipment(type) {
      this.isUnlistedEquipment = true;
      let item = {
        projectionItemEquipment: "OTHER",
        projectionItemQuantity: Number(this.planningSheetItemObject.quantity),
        projectionItemShifts: Number(
          this.planningSheetItemObject.selectedShift
            ? this.planningSheetItemObject.selectedShift
            : 1
        ),
        projectionItemStartDate:
          this.planningSheetItemObject.projectionStartDate,
        projectionItemEndDate: this.planningSheetItemObject.projectionEndDate,
        projectionItemOperatorCertification: this.planningSheetItemObject
          .projectionItemOperatorCertification
          ? this.planningSheetItemObject.projectionItemOperatorCertification
          : false,
        projectionItemDelivery: this.planningSheetItemObject
          .projectionItemDelivery
          ? this.planningSheetItemObject.projectionItemDelivery
          : false,
        isDeleted: false,
        isOptionalItem: false,
        salePrice: 0,
        projectionItemCategory: "",
        hierarchyTypNm: "",
        projectionItemCategoryDescription: "",
        projectionItemEquipmentDescription:
          this.planningSheetItemObject.projectionItemEquipmentDescription,
        poNo: this.planningSheetItemObject.projectionPONo,
        jobNo: this.planningSheetItemObject.projectionJobNo,
        pickedUpBy: this.planningSheetItemObject.pickedUpBy,
        orderedBy: this.planningSheetItemObject.orderedBy,
      };
      if (type == "Edit") {
        item["projectionItemID"] = this.storeProjectionItemID
          ? this.storeProjectionItemID
          : "";
      }
      let payload = {
        item: item,
        suggestedItems: [],
      };
      if (
        type == "Add" &&
        this.storeProjectionID &&
        !this.storeProjectionItemID
      ) {
        try {
          let response = await smsServiceNew.postReviewItemsList(
            this.storeProjectionID,
            payload
          );
          if (response && response.isSuccess) {
            this.getReviewSheetList();
            this.closeUnlistedEquipmentDialog();
            this.$toast.success("Unlisted equipment added successfully");
          } else {
            this.isUnlistedEquipment = false;
            this.$toast.error("Unable to add unlisted equipment");
          }
          this.isUnlistedEquipment = false;
        } catch (err) {
          this.isUnlistedEquipment = false;
          this.$toast.error("Unable to add unlisted equipment");
          console.log(err);
        }
      } else if (
        type == "Edit" &&
        this.storeProjectionID &&
        this.storeProjectionItemID
      ) {
        try {
          let response = await smsServiceNew.putReviewItemsList(
            this.storeProjectionID,
            this.storeProjectionItemID,
            payload
          );
          if (response && response.isSuccess) {
            this.getReviewSheetList();
            this.closeUnlistedEquipmentDialog();
            this.$toast.success("Unlisted equipment updated successfully");
          } else {
            this.isUnlistedEquipment = false;
            this.$toast.error("Unable to update unlisted equipment");
          }
          this.isUnlistedEquipment = false;
        } catch (err) {
          this.isUnlistedEquipment = false;
          this.$toast.error("Unable to update unlisted equipment");
          console.log(err);
        }
      }
    },
    sugQuantity(index, qty) {
      if (qty > 0) {
        this.SuggestedItems[index - 1]["isSugAddCheck"] = true;
      } else {
        this.SuggestedItems[index - 1]["isSugAddCheck"] = false;
      }
    },
    sugItemAddCheck(index, addCheck) {
      if (addCheck) {
        this.SuggestedItems[index - 1]["sugItemQty"] = "1";
      } else {
        this.SuggestedItems[index - 1]["sugItemQty"] = "";
      }
    },
    // The rows the user ticked in the suggested-items list. Identical for the
    // post and put flows.
    buildSuggestedItems() {
      let suggestedItems = [];
      for (var i = 0; i < this.SuggestedItems.length; i++) {
        if (this.SuggestedItems[i]["isSugAddCheck"] == true) {
          let suggestedItem = {
            projectionItemEquipment: this.SuggestedItems[i]["itemKey"],
            projectionItemQuantity: Number(
              this.SuggestedItems[i]["sugItemQty"]
            ),
            projectionItemShifts: Number(
              this.planningSheetItemObject.selectedShift
                ? this.planningSheetItemObject.selectedShift
                : 1
            ),
            projectionItemStartDate:
              this.planningSheetItemObject.projectionStartDate,
            projectionItemEndDate:
              this.planningSheetItemObject.projectionEndDate,
            projectionItemOperatorCertification: this.planningSheetItemObject
              .projectionItemOperatorCertification
              ? this.planningSheetItemObject.projectionItemOperatorCertification
              : false,
            projectionItemDelivery: this.planningSheetItemObject
              .projectionItemDelivery
              ? this.planningSheetItemObject.projectionItemDelivery
              : false,
            isDeleted: false,
            isOptionalItem: false,
            salePrice: this.equipmentDetailsobj.salePrice,
            projectionItemCategory:
              this.planningSheetItemObject.projectionItemCategory,
            hierarchyTypNm: this.equipmentDetailsobj.hierarchyTypNm,
            projectionItemCategoryDescription:
              this.planningSheetItemObject.projectionItemCategoryDescription,
            projectionItemEquipmentDescription: "",
            poNo: this.planningSheetItemObject.projectionPONo,
            jobNo: this.planningSheetItemObject.projectionJobNo,
            pickedUpBy: this.planningSheetItemObject.pickedUpBy,
            orderedBy: this.planningSheetItemObject.orderedBy,
          };
          suggestedItems.push(suggestedItem);
        }
      }
      return suggestedItems;
    },
    async putSuggestedItems(item) {
      let suggestedItems = this.buildSuggestedItems();
      let payload = {
        item: item,
        suggestedItems: suggestedItems,
      };
      try {
        let response = await smsServiceNew.putReviewItemsList(
          this.storeProjectionID,
          this.storeProjectionItemID,
          payload
        );
        if (response && response.isSuccess) {
          this.addItemPlanningSheet = false;
          this.$toast.success("Items updated successfully");
        } else {
          this.$toast.error(response.systemMessage);
          this.addItemPlanningSheet = false;
        }
        this.getReviewSheetList();
      } catch (err) {
        this.addItemPlanningSheet = false;
        this.$toast.error("Unable to update items");
        console.log(err);
      }
    },
    async postSuggestedItems(item) {
      let suggestedItems = this.buildSuggestedItems();
      let payload = {
        item: item,
        suggestedItems: suggestedItems,
      };
      try {
        let response = await smsServiceNew.postReviewItemsList(
          this.storeProjectionID,
          payload
        );
        if (response && response.isSuccess) {
          this.addItemPlanningSheet = false;
          this.$toast.success("Items added successfully");
        } else {
          this.$toast.error(response.systemMessage);
          this.addItemPlanningSheet = false;
        }
        this.getReviewSheetList();
      } catch (err) {
        this.addItemPlanningSheet = false;
        this.$toast.error("Unable to add items");
        console.log(err);
      }
    },
    async getSuggestedItemsList(itemKey, isGetSuggestedItems = false) {
      try {
        this.SuggestedItems = [];
        this.sugLoading = true;
        let response = await smsServiceNew.getSuggest(itemKey);
        if (response && response.isSuccess && response.data) {
          this.SuggestedItems = response.data.map((x, index) => ({
            ...x,
            sno: index + 1,
            isSugAddCheck: false,
            sugItemQty: "",
          }));
          if (isGetSuggestedItems) {
            this.getSuggestedItemsById();
          } else {
            this.sugLoading = false;
          }
        } else {
          this.SuggestedItems = [];
          this.sugLoading = false;
        }
      } catch (err) {
        this.sugLoading = false;
        console.log(err);
      }
    },
    async getSuggestedItemsById() {
      try {
        let response = await smsServiceNew.getSuggestedItemsById(
          this.storeProjectionID,
          this.storeProjectionItemID
        );
        if (response && response.isSuccess && response.data) {
          let sugItemData = response.data.suggestedItems;
          for (var i = 0; i < this.SuggestedItems.length; i++) {
            for (var j = 0; j < sugItemData.length; j++) {
              if (
                this.SuggestedItems[i]["itemKey"] ==
                sugItemData[j]["projectionItemEquipment"]
              ) {
                this.SuggestedItems[i]["isSugAddCheck"] = true;
                this.SuggestedItems[i]["sugItemQty"] =
                  sugItemData[j]["projectionItemQuantity"];
              }
            }
          }
        }
        this.sugLoading = false;
      } catch (err) {
        this.sugLoading = false;
        console.log(err);
      }
    },
    cancelAndGoToCurrentSheets() {
      this.goAllPlanningSheets();
      this.clearSheetData();
    },
    radioInputChange() {
      if (this.jobSiteRadioInput == "1") {
        this.newJobSite = "";
      } else {
        this.planningSheetObject.projectionJobSite = "";
      }
    },
    deleteSearchTermChip(index, name) {
      if (this.addSearchTerm.includes(("," && name) || (name && ","))) {
        this.addSearchTerm = this.addSearchTerm.replace(name, "");
        this.addSearchTerm = this.addSearchTerm.replace(/\$|,/g, " ");
        this.addSearchTerm = this.addSearchTerm.replace(";", " ");
        this.addSearchTerm = this.addSearchTerm.replace(" ", " ");
      }
      this.searchTermChips.splice(index, 1);
      this.SearchEquipment();
    },
    SearchEquipment() {
      let tempChips = [];
      tempChips = this.addSearchTerm.split("," && " ");
      for (var k = 0; k < tempChips.length; k++) {
        if (tempChips[k].trim()) {
          this.searchTermChips.push({
            index: k,
            name: tempChips[k],
          });
        }
      }
      this.addSearchTerm = "";
      this.categoryNameList = [];
      this.depNameList = [];
      this.groupNameList = [];
      this.equipmentGlobalSearch = [];
      if (this.searchTermChips.length == 0) {
        this.hideAllCategoryBtn = false;
        this.getProjectionItemsList();
      } else {
        // If item is in search, add/push it.
        for (let i = 0; i < this.projectionItems.length; i++) {
          let test = true;
          for (let j = 0; j < this.searchTermChips.length; j++) {
            if (
              this.projectionItems[i].itemNm
                .toLowerCase()
                .search(this.searchTermChips[j].name.toLowerCase()) == -1
            ) {
              test = false;
              break;
            }
          }
          if (test) {
            this.equipmentGlobalSearch.push(this.projectionItems[i]);
          }
          this.categorylist = this.equipmentGlobalSearch;
        }
        this.groupclick = true;
        this.categoryclick = false;
        this.departmentclick = false;
        this.showequipmentDetailsClick = false;
        this.imgCategoryName = "Equipment";
        this.hideAllCategoryBtn = true;
        this.addSearchTerm = "";
      }
      this.resetItemSettingsToDefault();
    },

    openRejectItemDialog() {
      this.rejectConfirmationDialog = true;
      this.rejectionReason = "";
    },
    closeRejectItemsDialog() {
      this.rejectConfirmationDialog = false;
      this.rejectionReason = "";
    },
    openApproveItemDialog() {
      this.approveConfirmationDialog = true;
    },
    closeApproveItemsDialog() {
      this.approveConfirmationDialog = false;
    },
    async approveItems() {
      this.isItemsSubmit = true;
      try {
        let response = await smsServiceNew.finalSubmitOfItems(
          this.storeProjectionID
        );
        if (response && response.isSuccess) {
          this.$toast.success("Planning sheet approved successfully");
          this.getReviewSheetList();
          this.$router.push({ name: "View Current Sheets" });
          this.isItemsSubmit = false;
        } else {
          this.$toast.error("Unable to approve");
          this.isItemsSubmit = false;
        }
      } catch (err) {
        this.isItemsSubmit = false;
        this.$toast.success("Unable to approve the planning sheet");
        console.log(err);
      }
    },
    async rejectItems() {
      this.isRejectItems = true;
      let payload = { RejectionReason: this.rejectionReason };
      try {
        let response = await smsServiceNew.rejectItems(
          this.storeProjectionID,
          payload
        );
        if (response && response.isSuccess) {
          this.$toast.success("Planning sheet rejected successfully");
          this.getReviewSheetList();
          this.$router.push({ name: "View Current Sheets" });
          this.isRejectItems = false;
        } else {
          this.$toast.error("Unable to reject");
          this.isRejectItems = false;
        }
      } catch (err) {
        this.isRejectItems = false;
        this.$toast.success("Unable to reject the planning sheet");
        console.log(err);
      }
    },
    handleItemsClick() {
      this.$store.dispatch("setPlanningSheetTabPrev", 2);
      this.getMasterItemsList(false);
    },
    handleBack() {
      if (this.createPlanningSheetTabPrev != null) {
        this.planningSheetTab = this.createPlanningSheetTabPrev;
        this.$store.dispatch(
          "setPlanningSheetTab",
          Number(this.planningSheetTab)
        );
      } else {
        if (this.$store.getters.projectionItemRoute == "Current Sheets") {
          this.$router.push({ name: "View Current Sheets" });
        } else {
          this.$router.push({ name: "View Historical Sheets" });
        }
      }
    },
    openNotes(item) {
      this.additionalNotes1 = item.additionalNotes1;
      this.additionalNotes2 = item.additionalNotes2;
      this.itemId = item.projectionItemID;
      this.notesDialog = true;
    },
    async saveNotes() {
      this.isSaveNotesLoading = true;
      let payload = {
        projectionItemID: this.itemId,
        additionalNotes1: this.additionalNotes1,
        additionalNotes2: this.additionalNotes2,
      };
      try {
        let response = await smsServiceNew.updateAdditionalNotes(payload);
        if (response.isSuccess) {
          this.isSaveNotesLoading = false;
          this.$toast.success(" Updated additional notes successfully");
          this.notesDialog = false;
          this.additionalNotes1 = null;
          this.additionalNotes2 = null;
          this.itemId = null;
          this.getReviewSheetList();
        } else {
          this.isSaveNotesLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isSaveNotesLoading = false;
      }
      this.getReviewSheetList();
      this.notesDialog = false;
      this.additionalNotes1 = null;
      this.additionalNotes2 = null;
      this.itemId = null;
    },
    closeNotes() {
      this.notesDialog = false;
      this.additionalNotes1 = null;
      this.additionalNotes2 = null;
      this.itemId = null;
    },
    async unlockProject(id) {
      this.isItemsLocked = true;
      try {
        let response = await smsServiceNew.unlockPlanningsheet(id);
        if (response && response.isSuccess) {
          this.$toast.success("Unlocked the project successfully");
          this.isItemsLocked = false;

          this.getReviewSheetList();
          this.$router.push({ name: "View Current Sheets" });
        } else {
          this.$toast.error("Unable to unlock the project");
          this.isItemsLocked = false;
        }
      } catch (err) {
        this.$toast.error("Unable to unlock the project");
        console.log(err);
        this.isItemsLocked = false;
      }
    },

    async lockProject(id) {
      this.isItemsLocked = true;
      try {
        let response = await smsServiceNew.lockPlanningsheet(id);
        if (response && response.isSuccess) {
          this.$toast.success("Locked the project successfully");
          this.isItemsLocked = false;

          this.getReviewSheetList();
          this.$router.push({ name: "View Current Sheets" });
        } else {
          this.$toast.error("Unable to lock the project");
          this.isItemsLocked = false;
        }
      } catch (err) {
        this.$toast.error("Unable to lock the project");
        console.log(err);
        this.isItemsLocked = false;
      }
    },
    async notifyProject(id) {
      this.isItemsNotified = true;
      try {
        let response = await smsServiceNew.notifyPlanningsheet(id);
        if (response && response.isSuccess) {
          this.$toast.success("notified successfully");
          this.isItemsNotified = false;
        } else {
          this.$toast.error("Unable to notify");
          this.isItemsNotified = false;
        }
      } catch (err) {
        this.$toast.error("Unable to notify");
        this.isItemsNotified = false;

        console.log(err);
      }
    },
  },
};
